import { Component, ComponentInterface, Event, EventEmitter, h, Host, JSX, Prop } from '@stencil/core';
import { BannerVariant } from '../../types/BannerVariant';
import { Icons } from '../../types/Icons';
import { ButtonLabels } from '../../types/ButtonLabels';
import { TRACKING_EVENT_TYPE } from '@usercentrics/cmp-browser-sdk';

import { Events } from '../../constants';

@Component({
  tag: 'cmm-buttons-wrapper',
  styleUrl: 'cmm-buttons-wrapper.scss',
  shadow: false,
})
export class ButtonsWrapper implements ComponentInterface {
  @Prop() handlerAcceptAll: () => void;
  @Prop() handlerDeny: () => void;
  @Prop() handlerToggleDetails: () => void;
  @Prop() handlerSaveSelection: () => void;
  @Prop() labels: ButtonLabels;
  @Prop() variant: BannerVariant;

  @Event({
    eventName: Events.TRACK,
    bubbles: true,
  })
  trackEvent: EventEmitter<TRACKING_EVENT_TYPE>;
  handleClick(): void {
    this.handlerToggleDetails();
    this.trackEvent.emit(TRACKING_EVENT_TYPE.MORE_INFORMATION_LINK);
  }

  public render(): JSX.Element {
    if (!this.labels && !this.variant) {
      return false;
    }

    return (
      <Host>
        <div class="buttons-wrapper">
          <div class="button-group">
            {this.variant === BannerVariant.ThreeButtons && (
              <wb7-button
                class="button button--only-technically-necessary"
                data-test="handle-deny-button"
                variant="secondary"
                size="s"
                onClick={(): void => this.handlerDeny()}
              >
                {this.labels?.deny}
              </wb7-button>
            )}
            {this.variant !== BannerVariant.Categories && (
              <wb7-button
                class="button button--toggle-cookie-details"
                data-test="toggle-cookie-details"
                variant="secondary"
                size="s"
                onClick={(): void => this.handleClick()}
              >
                {this.labels?.toggle}
              </wb7-button>
            )}
            {this.variant === BannerVariant.Categories && (
              <wb7-button
                class="button button--confirm-selection"
                data-test="handle-confirm-selection-button"
                variant="secondary"
                size="s"
                onClick={(): void => this.handlerSaveSelection()}
              >
                {this.labels?.save}
              </wb7-button>
            )}
            <wb7-button
              class="button button--accept-all"
              data-test="handle-accept-all-button"
              variant="secondary"
              size="s"
              onClick={(): void => this.handlerAcceptAll()}
            >
              {this.labels?.acceptAll}
            </wb7-button>
          </div>
          {this.variant === BannerVariant.Categories && (
            <wb7-button
              class="toggle-button"
              data-test="toggle-cookie-details"
              variant="tertiary"
              size="s"
              onClick={(): void => this.handleClick()}
            >
              <cmm-icon name={Icons.ARROW_UP} aria-hidden="true"></cmm-icon>
              {this.labels?.showDetails}
            </wb7-button>
          )}
        </div>
      </Host>
    );
  }
}
